{
  "main": [
    { "id": "resume", "label": "Resume", "hint": "Back to the cockpit" },
    { "id": "openDashboard", "label": "Dashboard", "hint": "Ship, jobs, fleet, intel, ledger and log · Tab" },
    { "id": "openSaves", "label": "Save & Load", "hint": "Manual save, load and export" },
    { "id": "openSettings", "label": "Settings", "hint": "Controls feel, aim assist, graphics, screen shake and interface" },
    { "id": "openAudio", "label": "Audio", "hint": "Volumes, hull effect, night mode and mono" },
    { "id": "openControls", "label": "Controls", "hint": "Every key and pad binding" },
    { "id": "openHelp", "label": "Help", "hint": "How to fly, trade and use the dashboard; HUD legend" },
    { "id": "quitTitle", "label": "Quit to title", "hint": "Autosave and return to the title" }
  ],
  "titles": {
    "main": "Paused",
    "saves": "Save & Load",
    "settings": "Settings",
    "audio": "Audio",
    "controls": "Controls",
    "help": "Help",
    "helpPage": "Help",
    "quit": "Quit to title?"
  },
  "back": { "label": "Back", "hint": "Return to the pause menu" },
  "helpBack": { "label": "Back", "hint": "Return to the help pages" },
  "cancel": { "label": "Cancel", "hint": "Stay in the pause menu" },
  "quitConfirm": { "label": "Quit to title", "hint": "Autosave now and return to the title screen" },
  "closeDashboard": { "label": "Close dashboard", "hint": "Close the dashboard and return to the cockpit" },
  "dashboardUnavailable": "The dashboard opens in flight only",
  "saves": {
    "save": "Save",
    "load": "Load",
    "export": "Export",
    "inCombat": "Can't save in combat",
    "noCareer": "No career is running",
    "noStorage": "Saves can't be stored in this browser",
    "manualOnly": "Autosaves are written by the game",
    "emptySlot": "This slot is empty",
    "unreadable": "This save can't be loaded",
    "lastSave": "Last save {ago}",
    "never": "No save yet",
    "saved": "Saved to {slot}",
    "loaded": "Loaded {slot}",
    "exported": "Exported {file}",
    "failed": "Couldn't do that: {error}",
    "quitFailed": "Autosave failed: {error}. Still paused.",
    "noTitle": "There is no title screen in this mode",
    "ago": { "now": "just now", "minutes": "{n} min ago", "hours": "{n} h ago", "days": "{n} d ago" },
    "when": "{day} {month} {hh}:{mm}",
    "months": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    "actionHints": { "save": "Enter: save here", "load": "Enter: load this save", "export": "Enter: export to a file" }
  },
  "scrollCue": "More below",
  "interface": {
    "group": "Interface",
    "rows": {
      "uiScale": { "label": "UI scale", "hint": "Size of menus, panels and the dashboard; the flight HUD stays within 75–150 %" },
      "textContrast": { "label": "Text contrast", "hint": "High brightens secondary text, makes panels opaque and thickens rules" },
      "reducedMotion": { "label": "Reduced motion", "hint": "Turns off pulses, slide-ins and animated transitions; Follow OS uses your system setting" },
      "hudLabels": { "label": "HUD labels", "hint": "How many nav labels keep their names: Full 10, Reduced 6, Minimal only the target and route" },
      "dashboardTime": { "label": "Dashboard time", "hint": "Pause holds the world while the dashboard is open; Keep running lets it run" },
      "holdToConfirm": { "label": "Hold to confirm", "hint": "Hold the button to sell all, jettison cargo or abandon a claim" }
    },
    "options": {
      "textContrast": { "standard": "Standard", "high": "High" },
      "reducedMotion": { "system": "Follow OS", "off": "Off", "on": "On" },
      "hudLabels": { "full": "Full", "reduced": "Reduced", "minimal": "Minimal" },
      "dashboardTime": { "pause": "Pause", "keepRunning": "Keep running" }
    }
  }
}
